import axios from 'axios';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createNotification } from '../helpers/Notification';
import Loader from '../common/Loader';
import { checkValidPasswpord, isImage, checkImageSize, getApiUrl } from '../helpers/Util';
import { FaPen } from 'react-icons/fa';
import SimpleReactValidator from 'simple-react-validator';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginUserData } from '../project/redux/projectAction';
import { useNavigate } from 'react-router-dom';
import projectServices from '../project/services/projectServices';

const UserProfile = () => {
  const dispatch = useDispatch();
  const loginUserData = useSelector(state => state.loginUserData);
  const navigate = useNavigate();
  const validator = useRef(new SimpleReactValidator());
  const [state, setState] = useState({
    token: '',
    name: '',
    email: '',
    phoneNum: '',
    organization: 1,
    country: '',
    userId: '',
    password: '',
    confirmPassword: '',
    loader: false,
    selectedFile: null,
    imagePreviewUrl: null,
    onchangeImg: false,
    dbImage: null
  });
  const [, forceUpdate] = useState();

  useEffect(() => {
    const token = localStorage.getItem('user-token');
    const userId = localStorage.getItem('userId');
    setState(prev => ({ ...prev, token, userId }));
    getLoginUserData();
    // eslint-disable-next-line
  }, []);

  const fileChangedHandler = (event) => {
    if (isImage(event.target.files[0].name)) {
      if (checkImageSize(event.target.files[0].size)) {
        setState(prev => ({ ...prev, selectedFile: event.target.files[0] }));
        let reader = new FileReader();
        reader.onloadend = () => {
          setState(prev => ({ ...prev, imagePreviewUrl: reader.result, onchangeImg: true }));
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        createNotification('info', 'Maximum limit to upload is 5 MB');
      }
    } else {
      createNotification('info', 'Please select valid image format!');
    }
  };

  const onCancelImg = () => {
    setState(prev => ({ ...prev, imagePreviewUrl: null, onchangeImg: false }));
  };

  const onSaveImg = () => {
    let loginUserDataClone = { ...loginUserData };
    const { token, selectedFile } = state;
    const headers = { 'Authorization': `Bearer ${token}` };
    setState(prev => ({ ...prev, loader: true }));
    const URL = getApiUrl();
    const url = `${URL}/profileUpload`;
    var fd = new FormData();
    fd.append('profileImage', selectedFile);
    axios.post(url, fd, { headers })
      .then((response) => {
        setState(prev => ({
          ...prev,
          onchangeImg: false,
          loader: false,
          imagePreviewUrl: null,
          dbImage: response.data.data.filePath
        }));
        localStorage.setItem('profileImage', response.data.data.filePath);
        dispatch(setLoginUserData({ ...loginUserDataClone, profileImage: response.data.data.filePath }));
      })
      .catch((error) => {
        setState(prev => ({ ...prev, loader: false }));
        if (error.response && error.response.status === 401) {
          createNotification('error', 'Your login session has been expired!');
          localStorage.clear();
          navigate('/login');
        } else {
          createNotification('error', error.response?.data?.message || 'An error occurred');
        }
      });
  };

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setState(prev => ({ ...prev, [name]: value }));
  };

  const checkInputData = () => {
    const { name, email, phoneNum } = state;
    let isValidate = true;
    if (name === '') {
      createNotification('error', 'User name is required!');
      isValidate = false;
    } else if (email === '') {
      createNotification('error', 'Email is required!');
      isValidate = false;
    } else if (phoneNum === '') {
      createNotification('error', 'Phone Number is required!');
      isValidate = false;
    }
    return isValidate;
  };

  const getLoginUserData = () => {
    try {
      projectServices.getUserDetailByToken().then((res) => {
        if (res.data.status) {
          let result = res.data.data;
          setState(prev => ({ ...prev, name: result.name, email: result.email, phoneNum: result.phone, dbImage: result.profileImage }));
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          createNotification('error', 'Your login session has been expired!');
          localStorage.clear();
          navigate('/login');
          setState(prev => ({ ...prev, loader: false }));
        } else {
          createNotification('error', error.response?.data?.message || 'An error occurred');
          setState(prev => ({ ...prev, loader: false }));
        }
      });
    } catch (error) {
      // eslint-disable-next-line
    }
  };

  const handleEditUser = () => {
    const { name, email, phoneNum, userId, organization, country, password, confirmPassword, token } = state;
    let loginUserDataClone = { ...loginUserData };
    if (validator.current.allValid()) {
      if (password !== '' && confirmPassword === '') {
        createNotification('error', 'Confirm Password is required!');
        return false;
      } else if (password !== '' && confirmPassword !== password) {
        createNotification('info', 'Confirm Password and Password do not match!');
        return false;
      } else if (password !== '' && confirmPassword !== '' && !checkValidPasswpord(password)) {
        createNotification('info', 'Passwords must be 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!');
        return false;
      }
      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      };
      setState(prev => ({ ...prev, loader: true }));
      const URL = getApiUrl();
      const url = `${URL}/edit-profile`;
      let data = { name, email, phone: phoneNum ? phoneNum : '', organization: Number(organization), status: 'Active' };
      if (password !== '') {
        data.password = password;
      }
      axios.patch(url, data, { headers })
        .then((response) => {
          if (response.status === 200) {
            createNotification('success', 'Profile Updated successfully!');
            dispatch(setLoginUserData({ ...loginUserDataClone, userName: name }));
            localStorage.setItem('userName', name);
            setState(prev => ({ ...prev, loader: false }));
          }
        })
        .catch((error) => {
          setState(prev => ({ ...prev, loader: false }));
          if (error.response && error.response.status === 401) {
            createNotification('error', 'Your login session has been expired!');
            localStorage.clear();
            navigate('/login');
          } else {
            createNotification('error', error.response?.data?.message || 'An error occurred');
          }
        });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const { loader, onchangeImg, imagePreviewUrl, dbImage } = state;
  const imgUrl = imagePreviewUrl ? imagePreviewUrl : dbImage;
  let imagePreview = (<div className="imagePreview"></div>);
  if (imgUrl) {
    imagePreview = (<div className="imagePreview" style={{ backgroundImage: `url(${imgUrl})` }} ></div>);
  }

  return (
    <div>
      {loader ? <Loader /> :
        <div className="main-content addUser-form">
          <div className="page-content">
            <div className="container-fluid">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">My profile</h4>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card card-block">
                    <div className="card-body">
                      <div className="wizard clearfix">
                        <div className="content clearfix">
                          <form className="form-project ">
                            <div className="row">
                              <div className="col-sm-12 col-md-3 imgUp uploadFile-image">
                                <div className="mb-3 uploadImgWrap">
                                  {imagePreview}
                                  <label className="btn btn-primary">
                                    <FaPen />
                                    <input type="file" className="uploadFile img" value=""
                                      style={{ width: "0px", height: "0px", overflow: "hidden" }} onChange={fileChangedHandler} />
                                  </label>
                                </div>
                              </div>
                              {onchangeImg &&
                                <>
                                  <div className="row">
                                    <div className="col-sm-12 col-md-2">
                                      <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onSaveImg} >
                                        <i className="uil uil-save"></i> Save
                                      </button>
                                    </div>
                                    <div className="col-sm-12 col-md-2">
                                      <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onCancelImg} >
                                        <i className="uil uil-cancel"></i> Cancel
                                      </button>
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}></div>
                                </>
                              }
                            </div>
                            <div className="row">
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom01">Name <span style={{ color: 'red' }}>*</span></label>
                                  <input type="text" className="form-control" value={state.name}
                                    name="name" onChange={handleOnChange} placeholder="Name"
                                    required />
                                  {validator.current.message('name', state.name, 'required|max:50', { className: 'text-danger' })}
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom01">Email ID <span style={{ color: 'red' }}>*</span></label>
                                  <input type="text" className="form-control" value={state.email}
                                    name="email" onChange={handleOnChange} placeholder="Email"
                                    disabled />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4 col-sm-12">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="validationCustom02">Phone Number <span style={{ color: 'red' }}>*</span></label>
                                  <input type="text" className="form-control" id="validationCustom02"
                                    name="phoneNum"
                                    value={state.phoneNum} onChange={handleOnChange} placeholder="Phone number"
                                  />
                                  {validator.current.message('Phone Number', state.phoneNum, 'required|numeric|min:10|max:10', { className: 'text-danger' })}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div className="actions clearfix">
                          <button type="button" className="btn btn-primary waves-effect waves-light" onClick={handleEditUser}>
                            <i className="uil uil-save"></i> Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default UserProfile;